import {
  GET_CHARITY_LIKE_REQUEST,
  GET_CHARITY_LIKE_SUCCESS,
  GET_CHARITY_LIKE_ERROR,
  TOGGLE_CHARITY_LIKE_REQUEST,
  TOGGLE_CHARITY_LIKE_SUCCESS,
  TOGGLE_CHARITY_LIKE_ERROR
} from "../actions/charityActions";

const initialState = {
  charityLike: {
    isLiked: false,
    data: null,
    loading: false,
    error: false,
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHARITY_LIKE_REQUEST:
      return {
        ...state,
        charityLike: {
          ...state.charityLike,
          data: null,
          loading: true,
          error: false
        }
      };
    case GET_CHARITY_LIKE_SUCCESS:
      return {
        ...state,
        charityLike: {
          isLiked: action.result ? action.result.isLiked: false,
          data: action.result,
          loading: false,
          error: false,
        }
      };
    case GET_CHARITY_LIKE_ERROR:
      return{
        ...state,
        charityLike: {
          ...state.charityLike,
          data: null,
          loading: false,
          error: true,
        }
      }
    case TOGGLE_CHARITY_LIKE_REQUEST:
      return {
        ...state,
        charityLike: {
          ...state.charityLike,
          loading: true,
          error: false
        }
      };
    case TOGGLE_CHARITY_LIKE_SUCCESS:
      return {
        ...state,
        charityLike: {
          isLiked: action.result.isLiked,
          data: action.result,
          loading: false,
          error: false
        }
      };
      case TOGGLE_CHARITY_LIKE_ERROR:
        return {
          ...state,
          charityLike: {
            ...state.charityLike,
            data: null,  
            loading: false,
            error: true
          }
        };
      default:
        return state;
  }
};

export default {
  initialState,
  reducer
}